/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialog_Upload_DescInputs */

const en_dialog_upload_desc = /** @type {(inputs: Dialog_Upload_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Drag PDFs, research papers, or articles into Listening to turn them into audio.`)
};

const es_dialog_upload_desc = /** @type {(inputs: Dialog_Upload_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Arrastra PDFs, artículos de investigación o artículos a Listening para convertirlos en audio.`)
};

/**
* | output |
* | --- |
* | "Drag PDFs, research papers, or articles into Listening to turn them into audio." |
*
* @param {Dialog_Upload_DescInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const dialog_upload_desc = /** @type {((inputs?: Dialog_Upload_DescInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialog_Upload_DescInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_dialog_upload_desc(inputs)
	return en_dialog_upload_desc(inputs)
});